import React, { Component } from 'react'
import Page from './Page'
import Style from './style.module.less'
import { observer } from 'mobx-react'

@observer
export default class extends Component {
  render() {
    return (
      <div className={Style.page}>
        <Page />
      </div>
    )
  }
}
